<template>
<div class="chapter">
<div class="inner_page">
<p class="epigraph-indented-space-after"><em>‘Patriotism is the last refuge of a scoundrel.’</em></p>
<p class="epigraph-source">Samuel Johnson (1709–1784)</p>
<p class="epigraph-source">James Boswell, <em>Life of Johnson,</em></p>
<p class="epigraph-source">entry for Friday, April 7, 1775</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?1d35d0b2